import { useState } from 'react'
import { apiURL } from '../../utilities/URLs'
import { useNavigate, useSearchParams } from 'react-router-dom'

import ertcLogo from '../../assets/ertcLogo.png'
import { account } from '../../classes/Account'
import { setStoredSessionId } from '../../utilities/tracking/sessionStorage'

function getSafeRedirect(redirect) {
  if (!redirect) return '/dashboard'
  try {
    const decoded = decodeURIComponent(redirect)
    if (decoded.startsWith('//') || /^https?:/i.test(decoded)) return '/dashboard'
    return decoded
  } catch {
    return '/dashboard'
  }
}

export default function Verify({ setShowNavBar }) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const email = encodeURIComponent(searchParams.get('email'))
  const redirect = getSafeRedirect(searchParams.get('redirect'))

  const [code, setCode] = useState('')
  const [error, setError] = useState('')
  const [verifyingCode, setVerifyingCode] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setVerifyingCode(true)

    const verifyResponse = await fetch(`${apiURL}/api/login/verify/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email,
        code
      }),
      credentials: 'include'
    })
    const verifyData = await verifyResponse.json()
    setVerifyingCode(false)

    if (verifyData.response.error) {
      console.error(verifyData.response.error)
      setError(verifyData.response.error)
    } else {
      account.setAccount(verifyData.response.account)
      account.accessToken = verifyData.response.accessToken
      localStorage.setItem('portalAccessToken', verifyData.response.accessToken)
      if (verifyData.response.sessionId)
        setStoredSessionId(verifyData.response.sessionId)
      setShowNavBar(true)
      navigate(redirect)
    }
  }
  return (
    <div className='w-screen h-screen flex flex-col items-center justify-center p-6 bg-slate-50 dark:bg-slate-900 transition-colors duration-300'>
      <div className='w-full flex flex-col items-center max-w-sm p-8 bg-white dark:bg-slate-800 shadow-xl dark:shadow-2xl dark:shadow-black/50 rounded-2xl border border-gray-100 dark:border-slate-700/50 dark:border-slate-700 transition-colors duration-300'>
        <img src={ertcLogo} alt='ERTC Logo' className='w-48 mb-8 drop-shadow-sm' />
        <h2 className='text-2xl font-bold mb-2 text-center text-gray-900 dark:text-white transition-colors duration-300'>Verify Your Email</h2>
        <p className='text-sm text-center mb-6 text-gray-600 dark:text-gray-400 transition-colors duration-300'>Please enter the 6-digit code sent to your email to continue.</p>
        <form onSubmit={handleSubmit} className='w-full flex flex-col gap-4'>
          <input
            type='text'
            inputMode='numeric'
            maxLength={6}
            pattern='[0-9]*'
            placeholder='Enter 6-digit code'
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
            className='p-3 border border-gray-300 dark:border-slate-600 rounded-lg w-full bg-white dark:bg-slate-800 dark:bg-slate-700/50 text-center text-lg tracking-widest text-gray-900 dark:text-white focus:ring-2 focus:ring-ertc-primary focus:border-ertc-primary outline-none transition-all duration-300 placeholder-gray-400 dark:placeholder-gray-500 shadow-sm'
          />
          {error && <p className='text-red-500 text-sm text-center font-medium animate-in fade-in'>{error}</p>}
          <button disabled={verifyingCode || !code || code.length < 6} type='submit' className={`w-full font-semibold transition-all duration-300 py-3 rounded-lg shadow-md active:scale-[0.98] ${verifyingCode || !code || code.length < 6 ? 'bg-gray-400 dark:bg-slate-600 cursor-not-allowed opacity-70' : 'bg-ertc-primary hover:bg-ertc-primary/90 hover:shadow-lg cursor-pointer text-white'}`}>
            Verify & Login
          </button>
          {verifyingCode && (
            <div className='flex flex-row items-center justify-center gap-3 mt-4 animate-in fade-in'>
              <div className='animate-spin rounded-full border-4 border-gray-200 dark:border-slate-700 border-t-ertc-primary h-6 w-6'></div>
              <p className='text-sm font-medium text-gray-600 dark:text-gray-400 transition-colors duration-300'>Verifying Code...</p>
            </div>
          )}
        </form>
      </div>
    </div>
  )
}